<template>
  <span
    class="s-badge"
    >{{badgeMsg}}{{badgeNumber}}<slot></slot>
    </span>

</template>

<script>
export default {
  props: {
    badgeMsg: {
      type: String,
      default: ''
    },
    badgeNumber: {
      type: Number,
      default: undefined
    }
  }
}
</script>
